import { projectDataType } from ".";

const swampData: projectDataType = {
  path: "swampspiritswarm",
  title: "Swamp Spirit Swarm",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965345/Art-Site/Swamp/swampSpiritSwarm-01.jpg",
  description:
    "Swamp Spirit Swarm is an Augmented Reality kinetic sculpture created for Kristin Lucas's exhibition Dance with FlARmingos. The exhibition originally took place in the grounds of Space Protocol in Gainsville, Florida. A second iteration of the exhibition was exhibited at the Queens Museum in Queens, New York, as part of Queens International 2016. The exhibition included AR guided tours with the curator Kristin Lucas.",
  year: 2015,
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965345/Art-Site/Swamp/swampSpiritSwarm-01.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965345/Art-Site/Swamp/13522955_10201657253508415_2747094069235121361_o_mhthts.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965344/Art-Site/Swamp/13497970_10201657258308535_7209201398029158530_o_mfwixs.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965345/Art-Site/Swamp/unspecified_dhfnt6.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965344/Art-Site/Swamp/unspecified-1_iypobc.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965345/Art-Site/Swamp/fdweifjlljfilj_uf38ei.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965345/Art-Site/Swamp/kristin-lucas-_71a3888-highres_cvuwox.jpg",
  ],
};

export default swampData;
